import { Stack, styled, Switch, Typography, useMediaQuery, useTheme } from '@mui/material'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import BootstrapTooltip from '@/components/base/BootstrapTooltip'
import { useState } from 'react'
import { useSolana } from '../../providers/solana'

const CustomSwitch = styled(Switch)(({ theme }) => ({
  width: 40,
  height: 24,
  padding: 7,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    top: '50%',
    left: 2,
    transform: 'translate(0, -50%)',
    '&.Mui-checked': {
      transform: 'translate(20px, -50%)',
      color: '#fff',
      '& .MuiSwitch-thumb': {
        backgroundColor: '#6DFCD1',
      },
      '& .MuiSwitch-thumb:before': {
        backgroundImage:
          "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23000000' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M20 6L9 17l-5-5'/%3E%3C/svg%3E\")", // Check mark
      },
      '& + .MuiSwitch-track': {
        backgroundColor: '#3d836f', // Track color when toggle is on
        opacity: 1,
        border: 0,
      },
    },
  },
  '& .MuiSwitch-thumb': {
    width: 16,
    height: 16,
    backgroundColor: '#FAFAFA', // Thumb color when toggle is off
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:before': {
      content: '""',
      width: '100%',
      height: '100%',
      backgroundImage:
        "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%2301010129' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M6 18L18 6M6 6l12 12'/%3E%3C/svg%3E\")", // Cross icon with color #01010129
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundSize: '60%',
    },
  },
  '& .MuiSwitch-track': {
    borderRadius: 13,
    backgroundColor: '#818081', // Track color when toggle is off
    opacity: 1,
  },
}))

const JitoValidatorSwitch = () => {
  const theme = useTheme()
  const isSmall = useMediaQuery(theme.breakpoints.up('sm'))
  const [iconColor, setIconColor] = useState('#FFFFFF7A')
  const { usingJitoValidator, setUsingJitoValidator } = useSolana()

  const handleSwitchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setUsingJitoValidator && setUsingJitoValidator(event.target.checked)
  }

  const handleIconClick = () => {
    if (!isSmall) {
      // Change icon color when clicked
      setIconColor('#FAFAFA')

      // Revert the color after 2 seconds
      setTimeout(() => {
        setIconColor('#FFFFFF7A')
      }, 1600)
    }
  }
  return (
    <Stack direction="row" justifyContent="space-between" className="py-0.5 lg:py-1.5">
      <Stack className="flex flex-row gap-1 items-center">
        <Typography className="text-white/50 text-xs-2 sm:text-sm font-dm_mono_regular">Use Jito</Typography>
        <BootstrapTooltip
          title="Use Jito for faster transactions during Solana congestion!"
          placement="top"
          className="font-dm_mono_regular"
          leaveDelay={isSmall ? 0 : 2000}
        >
          <HelpOutlineIcon
            sx={{
              color: iconColor,
              width: 24,
              height: 24,
              '&:hover': {
                color: { sm: '#DCC1FF' },
              },
            }}
            className="cursor-pointer"
            onClick={handleIconClick}
          />
        </BootstrapTooltip>
      </Stack>
      <CustomSwitch checked={usingJitoValidator} size="small" onChange={handleSwitchChange} />
    </Stack>
  )
}

export default JitoValidatorSwitch
